import { cache } from "react";

import { createQueryClient } from "./shared";

const getServerQueryClient = cache(createQueryClient);

let browserQueryClient: ReturnType<typeof createQueryClient> | undefined;

export const getQueryClient = () => {
  if (typeof window === "undefined") {
    return getServerQueryClient();
  }

  browserQueryClient ??= createQueryClient();
  return browserQueryClient;
};
